import { JobStatusName } from "@istari/istari-client";
import type { Job } from "@istari/istari-client";

export type StatusHistory = NonNullable<Job["statusHistory"]>;

const STATUS_ORDER: Record<string, number> = {
  [JobStatusName.Created]: 0,
  [JobStatusName.Pending]: 1,
  [JobStatusName.Claimed]: 2,
  [JobStatusName.Validating]: 3,
  [JobStatusName.Running]: 4,
  [JobStatusName.Uploading]: 5,
  [JobStatusName.Completed]: 6,
  [JobStatusName.Failed]: 7,
  [JobStatusName.Canceled]: 8,
  [JobStatusName.Unknown]: 9,
};

export function getLatestJobStatus(statusHistory: StatusHistory | undefined): StatusHistory[number] | undefined {
  if (!statusHistory || statusHistory.length === 0) return undefined;
  return [...statusHistory].sort((a, b) => {
    const timeDiff = new Date(b.created).getTime() - new Date(a.created).getTime();
    if (timeDiff !== 0) return timeDiff;
    return (STATUS_ORDER[b.name] ?? 0) - (STATUS_ORDER[a.name] ?? 0);
  })[0];
}

export function getLatestJobStatusName(statusHistory: StatusHistory | undefined): JobStatusName | undefined {
  return getLatestJobStatus(statusHistory)?.name;
}

export function getJobStatusMessage(status: StatusHistory[number] | undefined): string | undefined {
  const message = status?.message?.trim();
  return message ? message : undefined;
}

export function isJobRunning(status: string | undefined) {
  if (!status) return false;
  return (
    status === JobStatusName.Running ||
    status === JobStatusName.Claimed ||
    status === JobStatusName.Validating ||
    status === JobStatusName.Uploading
  );
}

export function isJobOpen(status: string | undefined) {
  return status === JobStatusName.Created || status === JobStatusName.Pending || isJobRunning(status);
}
